module.exports = __webpack_public_path__ + "img/artillery-wagon-base-shadow-4.d2e04c14.png";